export default "__VITE_PUBLIC_ASSET__f76f413f__"